import React from 'react';
import styled from 'styled-components';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faShieldAlt,
//   faFileAlt,
//   faBuilding,
// } from '@fortawesome/free-solid-svg-icons';

// ─── Styled Components ───────────────────────────────────────────────────────

const PageContainer = styled.div`
//   min-height: 100vh;
  background: #f8fafc;
  padding: 1.5rem;

  @media (min-width: 768px) {
    padding: 1.5rem 2.25rem;
  }
`;

const Header = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`;

const BackButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  background: #2563eb;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #1d4ed8;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: ${(props) => props.bg || 'transparent'};
`;

const CardIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 0.5rem;
  background: ${(props) => props.bg || '#f3f4f6'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color || '#2563eb'};
  font-size: 1.5rem;
`;

const CardTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
`;

const HeaderActions = styled.div`
  margin-left: auto;
`;

const ViewPolicyButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: white;
  background: #2563eb;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #1d4ed8;
  }
`;

const CardBody = styled.div`
  padding: 1.5rem;
  flex: 1;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const Label = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: #64748b;
`;

const Value = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e293b;
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 9999px;
  background: #fffbeb;
  color: #b45309;
`;

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ActionsBar = styled.div`
  background: white;
  border-radius: 0.75rem;
  padding: 3rem 0;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const SubmitButton = styled.button`
  padding: 0.75rem 2rem;
  font-weight: 500;
  color: white;
  background: #2563eb;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #1d4ed8;
  }
`;

const CancelButton = styled.button`
  padding: 0.75rem 2rem;
  font-weight: 500;
  color: #1e293b;
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f8fafc;
  }
`;

// ─── Component ───────────────────────────────────────────────────────────────

const ClaimDetails = ({ onBack }) => {
  return (
    <PageContainer>
      <Header>
        <Title>Claim Details</Title>
        <BackButton onClick={onBack}>Back</BackButton>
      </Header>

      <Grid>
        {/* Policy Details Card */}
        <Card>
          <CardHeader bg="#eff6ff">
            <CardIcon bg="#dbeafe" color="#1d4ed8">
              {/* <FontAwesomeIcon icon={faShieldAlt} /> */}
            </CardIcon>
            <CardTitle>Policy Details</CardTitle>

            <HeaderActions>
              <ViewPolicyButton>View Policy</ViewPolicyButton>
            </HeaderActions>
          </CardHeader>

          <CardBody>
            <InfoRow>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <div
                  style={{
                    width: '4rem',
                    height: '4rem',
                    background: '#f3f4f6',
                    borderRadius: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {/* <FontAwesomeIcon icon={faBuilding} style={{ fontSize: '1.5rem', color: '#2563eb' }} /> */}
                </div>
                <div style={{ flex: 1 }}>
                  <Label>Underwriter</Label>
                  <Value>Invincible Motor</Value> {/* fixed typo */}
                </div>
              </div>

              <TwoColumnGrid>
                <InfoItem>
                  <Label>Cover</Label>
                  <Value>3rd Party</Value>
                </InfoItem>
                <InfoItem>
                  <Label>Status</Label>
                  <Value>Active</Value>
                </InfoItem>
              </TwoColumnGrid>

              <TwoColumnGrid>
                <InfoItem>
                  <Label>Intermediary</Label>
                  <Value>Premium</Value>
                </InfoItem>
                <InfoItem>
                  <Label>Premium</Label>
                  <Value>KSh 50,000</Value>
                </InfoItem>
              </TwoColumnGrid>
            </InfoRow>
          </CardBody>
        </Card>

        {/* Claim Details Card */}
        <Card>
          <CardHeader bg="#fef2f2">
            <CardIcon bg="#fee2e2" color="#dc2626">
              {/* <FontAwesomeIcon icon={faFileAlt} /> */}
            </CardIcon>
            <CardTitle>Claim Details</CardTitle>
          </CardHeader>

          <CardBody>
            <InfoRow>
              <TwoColumnGrid>
                <InfoItem>
                  <Label>Claim Date</Label>
                  <Value>10/10/2024</Value>
                </InfoItem>
                <InfoItem>
                  <Label>Category</Label>
                  <Value>Report</Value>
                </InfoItem>
              </TwoColumnGrid>

              <TwoColumnGrid>
                <InfoItem>
                  <Label>Status</Label>
                  <StatusBadge>Work in Progress</StatusBadge>
                </InfoItem>
                <InfoItem>
                  <Label>Registration</Label> {/* suggested rename from "Procuring" */}
                  <Value>KBB 330X</Value>
                </InfoItem>
              </TwoColumnGrid>

              <TwoColumnGrid>
                <InfoItem>
                  <Label>Claim Ref</Label>
                  <Value>—</Value> {/* placeholder – replace with real ref */}
                </InfoItem>
                <InfoItem>
                  <Label>Claim Type</Label>
                  <Value>Accident</Value>
                </InfoItem>
              </TwoColumnGrid>
            </InfoRow>
          </CardBody>
        </Card>
      </Grid>

      <ActionsBar>
        <SubmitButton>Submit</SubmitButton>
        <CancelButton>Cancel</CancelButton>
      </ActionsBar>

      {/* ← Here you would place your Tabs component next */}
    </PageContainer>
  );
};

export default ClaimDetails;